// extracted by mini-css-extract-plugin
export default {"root":"PinchZoomPan_root__aQ+Bu","point":"PinchZoomPan_point__oTJLu","canvas":"PinchZoomPan_canvas__I+qOV"};